import { VisioService } from '@agent/core/channel-digit/visio/visio.service';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BehaviorSubject, first } from 'rxjs';

import { BookingFacade, UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'cng-visio-actions',
  templateUrl: 'visio-actions.component.html',
  styleUrls: ['./visio-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisioActionsComponent {
  private _isRecordInProgress$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private openTokArchiveId: string;
  appointmentId: string;

  constructor(private readonly visioService: VisioService, private readonly contactFacade: BookingFacade) {}

  ngOnInit() {
    this.contactFacade.selected$.pipe(first(), untilDestroyed(this)).subscribe(contact => {
      if (contact && contact.appointment) {
        this.appointmentId = contact.appointment.uuid;
      }
    });
  }

  hangUp() {
    this.visioService.destroy();
    this.visioService.closeVisioAppointment().subscribe();
  }

  get isRecordInProgress$() {
    return this._isRecordInProgress$.asObservable();
  }

  startVisioRecord() {
    this.visioService
      .startVisioArchiving(this.appointmentId)
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        if (response) {
          this.openTokArchiveId = response.toString();
          this._isRecordInProgress$.next(true);
        }
      });
  }

  stopVisioRecord() {
    this.visioService
      .stopVisioArchiving(this.appointmentId, this.openTokArchiveId)
      .pipe(untilDestroyed(this))
      .subscribe(response => {
        if (response) {
          this.openTokArchiveId = '';
          this._isRecordInProgress$.next(false);
        }
      });
  }
}
